export default __webpack_public_path__ + "fb6c1c17467f5212f43726cd45861da5.svg";